import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from 'reactstrap';
import QRCanvas from 'admin/components/shared/QRCanvas';
import Message from 'admin/components/shared/QRCanvas/Message';
import InputImageWrapper from '../InputImageWrapper';
import styles from './styles.scss';
import _ from 'lodash';
import {
  setBackgroundImage, setCaptionSize, setCaptionColor, enableNextPage, disableNextPage,
  enableBold, disableBold, enableItalic, disableItalic
} from 'admin/actions/qr-designer';

export class QRPage1 extends Component {
  constructor(props) {
    super(props);
  }

  updateCanNextPage() {
    if (this.props.background.image) {
      this.props.enableNextPage();
    } else {
      this.props.disableNextPage();
    }
  }

  componentDidMount() {
    this.updateCanNextPage();
  }

  componentDidUpdate() {
    this.updateCanNextPage();
  }

  draw(helper) {
    helper.clear();
    helper.drawImages();
  }

  handleChangeBackgroundImage = (files) => {
    if (files.length > 0) {
      const reader = new FileReader();
      reader.onload = () => {
        this.props.enableNextPage();
        this.props.setBackgroundImage(reader.result);
      }
      reader.readAsDataURL(files[0]);
    }
  }

  render() {
    const message = (
      <Message>
        <span style={{ fontFamily: 'Noto sans CJK JP', fontSize: '15px', marginBottom: '5px' }}>背景画像を選択</span>
        <span style={{ fontFamily: 'Noto sans CJK JP', fontSize: '16px' }}>1240x1748px</span>
      </Message>
    );
    const canvas = (
      <QRCanvas
        draggable={true}
        draw={this.draw}
        background={this.props.background} />
    );
    return (
      <InputImageWrapper onChange={this.handleChangeBackgroundImage}>
        {this.props.canNextPage ? null : message}
        {canvas}
      </InputImageWrapper>
    )
  }
}

export class QRPage2 extends Component {
  draw = (helper) => {
    helper.putQRImage(this.props.qrcode, { active: true });
  }

  render() {
    return (
      <QRCanvas
        draggable={true}
        draw={this.draw}
        background={this.props.background} />
    );
  }
}

const StyleButton = ({ text, kind, onChange, isEnable }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onChange(kind, !isEnable);
  }

  const getStyle = () => {
    if (isEnable) {
      switch (kind) {
        case 'italic':
          return styles.enableItalicButton;
        case 'bold':
          return styles.enableBoldButton;
      }
    } else {
      switch (kind) {
        case 'italic':
          return styles.disableItalicButton;
        case 'bold':
          return styles.disableBoldButton;
      }
    }
  }

  return (
    <input
      type='button'
      value={text}
      className={getStyle()}
      onClick={handleClick}
    />
  );
};

const ColorConfig = ({ color, onChange }) => (
  <React.Fragment>
    <label>
      <input
        type='color'
        className={styles.inputColor}
        value={color}
        onChange={onChange} />
    </label>
    <input
      className={styles.inputColorCode}
      value={color}
      disabled />
  </React.Fragment>
)

const SizeConfig = ({ onChange, size }) => (
  <Input
    type='select'
    className={styles.inputSize}
    onChange={onChange}
    value={`${size}px`}>
    {_.range(1, 100).map((n) => <option key={n}>{n}px</option>)}
  </Input>
);

const LetterConfig = ({ color, size, bold, italic, onChangeColor, onChangeFontSize, onChangeStyle }) => (
  <div className={styles.letterConfig}>
    <span className={styles.letterConfigTitle}>文字スタイル設定</span>
    <div className={styles.letterConfigBody}>
      <ColorConfig color={color} onChange={onChangeColor} />
      <SizeConfig onChange={onChangeFontSize} size={size} />
    </div>
    <div>
      {<StyleButton text='B' kind='bold' onChange={onChangeStyle} isEnable={bold} />}
      {/* {<StyleButton text='I' kind='italic' onChange={onChangeStyle} isEnable={italic} />} */}
    </div>
  </div>
);

export class QRPage3 extends Component {
  constructor(props) {
    super(props);
  }

  draw = (helper) => {
    helper.putQRImage(this.props.qrcode);
    helper.putCaption(this.props.caption, { active: true });
  }

  handleChangeFontSize = (e) => {
    const value = parseInt(e.target.value);
    if (!isNaN(value)) {
      this.props.setCaptionSize(value);
    }
  }

  handleChangeColor = (e) => {
    this.props.setCaptionColor(e.target.value);
  }

  handleChangeStyle = (kind, isEnable) => {
    switch (kind) {
      case 'bold':
        (isEnable ? this.props.enableBold : this.props.disableBold)();
        break;
      case 'italic':
        (isEnable ? this.props.enableItalic : this.props.disableItalic)();
        break;
    }
  }

  render() {
    return (
      <div className={styles.page}>
        <QRCanvas
          draggable={true}
          draw={this.draw}
          background={this.props.background} />
        <LetterConfig
          color={this.props.caption.color}
          size={this.props.caption.size}
          onChangeColor={this.handleChangeColor}
          onChangeFontSize={this.handleChangeFontSize}
          onChangeStyle={this.handleChangeStyle}
          bold={this.props.caption.bold}
          italic={this.props.caption.italic}
        />
      </div>
    );
  }
}

export class QRSample extends Component {
  drawObjects = (helper) => {
    helper.putQRImage(this.props.qrcode);
    helper.putCaption(this.props.caption);
  }

  draw = (helper) => {
    helper.drawImages();
  }

  render() {
    return (
      <div>
        {
          this.props.exists ?
            null :
            <Message>QRデザインが存在しません</Message>
        }
        <QRCanvas
          draggable={!this.props.exists}
          draw={!this.props.exists ? this.draw : this.drawObjects}
          background={this.props.background} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  canNextPage: state.qrDesigner.canNextPage,
  exists: state.qrDesigner.exists,
  qrcode: state.qrDesigner.qrcode,
  caption: state.qrDesigner.caption,
  background: {
    image: state.qrDesigner.backgroundImage,
    width: state.qrDesigner.size.width,
    height: state.qrDesigner.size.height,
  }
});

QRPage1 = connect(mapStateToProps, { setBackgroundImage, enableNextPage, disableNextPage })(QRPage1);
QRPage2 = connect(mapStateToProps)(QRPage2);
QRPage3 = connect(mapStateToProps, { setCaptionSize, setCaptionColor, enableBold, disableBold, enableItalic, disableItalic })(QRPage3);
QRSample = connect(mapStateToProps)(QRSample);
